module.exports = __webpack_public_path__ + "public/img/img_4.812d52ca.png";